import { useReactFlow } from '@xyflow/react';
import { useCallback } from 'react';

import { useReactFlowViewContext } from '../../../../context/context';

export function useUngroupNodes() {
  const { setNodes, getInternalNode } = useReactFlow();
  const { reactFlowMutators } = useReactFlowViewContext();

  const ungroupNodes = useCallback(
    (parentId: string) => {
      setNodes((priorNodes) => {
        return priorNodes
          .map((node) => {
            if (node.parentId === parentId) {
              return {
                ...node,
                position: {
                  x:
                    node.position.x +
                    (getInternalNode(parentId)?.internals.positionAbsolute.x ?? 0),
                  y:
                    node.position.y +
                    (getInternalNode(parentId)?.internals.positionAbsolute.y ?? 0),
                },
                expandParent: undefined,
                parentId: undefined,
                extent: undefined,
              };
            }
            return node;
          })
          .filter((node) => node.parentId !== parentId);
      });
      reactFlowMutators?.deleteNode(parentId);
    },
    [setNodes, reactFlowMutators, getInternalNode]
  );

  return { ungroupNodes };
}
